import { Antwoord, Controltype, ValidatieParameter, Vraag } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomAntwoord, VraagboomNumberResultaat } from '@models/vragenboom';
import { ValidatieregelHelper } from '@services/public_api';

// @dynamic
export class NumberValidator {
  static IsValidMinMax(antwoord: Antwoord, resultaat: VraagboomNumberResultaat) {
    if (antwoord == null) {
      return false;
    }

    if (resultaat && resultaat.value) {
      const minMaxNumberValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'MIN_MAX');
      if (minMaxNumberValidator != null) {
        const params = minMaxNumberValidator.validatie_parameters.split(';');
        if (params != null && params.length > 1) {
          const min = Number(params[0]);
          const max = Number(params[1]);

          if (!isNaN(min) && Number(resultaat.value) < min) {
            return false;
          }
          if (!isNaN(max) && Number(resultaat.value) > max) {
            return false;
          }
        }
      }
    }

    return true;
  }

  static isValidBedrag(vraag: Vraag, resultaat: VraagboomNumberResultaat): boolean {
    if (vraag == null ||
      (vraag.verplicht && (resultaat == null || !resultaat.value || resultaat.value.length === 0)) ||
      (resultaat && resultaat.value !== null && resultaat.value.toString() !== resultaat.value.toString().replace(/[^0-9,]/g, ''))
    ) {
      return false;
    }
    return true;
  }

  static isValidNumber(vraag: Vraag, resultaat: VraagboomNumberResultaat, resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): boolean {
    if (vraag == null ||
      (vraag.verplicht && (resultaat == null || !resultaat.value || resultaat.value.length === 0)) ||
      (vraag.control === Controltype.Number && resultaat && resultaat.value !== null && resultaat.value.toString() !== resultaat.value.toString().replace(/[^0-9]/g, '')
        && this.isGetalGroterGelijk(vraag.antwoorden[0], resultaat, resultaten))
    ) {
      return false;
    }
    return true;
  }

  static isValidDecimal(vraag: Vraag, resultaat: VraagboomNumberResultaat, resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): boolean {
    if (vraag == null ||
      (vraag.verplicht && (resultaat == null || !resultaat.value || resultaat.value.length === 0)) ||
      (resultaat && resultaat.value !== null && resultaat.value.toString() !== resultaat.value.toString().replace(/[^0-9.,]/g, ''))
    ) {
      return false;
    }
    if (!this.isGetalGroterGelijk(vraag.antwoorden[0], resultaat, resultaten)) {
      return false;
    }
    return true;
  }

  static isGetalGroterGelijk(antwoord: Antwoord, resultaat: VraagboomNumberResultaat, resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): boolean {
    if (antwoord == null) {
      return false;
    }

    if (resultaat?.value?.length > 0) {
      const validatie: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'GETAL_GROTER_GELIJK');

      if (validatie) {
        const compareWith = this.getComparisonValue(validatie.validatie_parameters, resultaten);

        if (compareWith) {
          return Number(resultaat.value?.replace(',', '.')) >= Number(compareWith);
        }
      }
    }
    return true;
  }

  static getComparisonValue(validatie_parameters: string, resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): number {
    let responseNumber = null;
    if (validatie_parameters.length > 0) {
      for (const resultaat of resultaten) {
        if (resultaat.vraag?.antwoorden?.length > 0) {
          if (resultaat.vraag.control === Controltype.Decimaal || resultaat.vraag.control === Controltype.Number) {
            resultaat.vraag.antwoorden.forEach((antw: Antwoord) => {
              if (antw.variabeleWaarde === validatie_parameters) {
                responseNumber = Number((resultaat as VraagboomAntwoord<VraagboomNumberResultaat>).resultaat.value?.replace(',', '.'));
                return;
              }
            });
          }
        }
      }
    }
    return responseNumber;
  }
}
